<template>
  <div class="elencocomponentiedit">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Modifica un componente</h5>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="codcatalogo" v-model="formData.componente.codcatalogo" :state="state.codcatalogo" type="text" placeholder="Codice componente da catalogo"/><label for="codcatalogo">* Codice Catalogo</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-select class="slide-up" id="idMarca" v-model="formData.componente.idMarca" :state="state.idMarca" :options="option.marche" placeholder="Seleziona la marca del componente" /><label for="idMarca">* Marca</label>
          <br>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-select class="slide-up" id="idTipocomponente" v-model="formData.componente.idTipocomponente" :state="state.idTipocomponente" :options="option.tipocomponente" placeholder="Seleziona una tipologia di componente" /><label for="idTipocomponente">* Tipologia di componente</label>
          <br>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-select class="slide-up" id="idSottotipocomponente" v-model="formData.componente.idSottotipocomponente" :state="state.idSottotipocomponente" :options="option.sottotipocomponente" placeholder="Seleziona una sotto tipologia di componente" /><label for="idSottotipocomponente">* Sotto tipologia di componente</label>
          <br>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="descrizione" v-model="formData.componente.descrizione" :state="state.descrizione" rows="3" max-rows="6" /><label for="descrizione">Descrizione</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="note" v-model="formData.componente.note" :state="state.note" rows="3" max-rows="6" /><label for="note">Note</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>DOCUMENTI COMPONENTE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h6>Documento 1</h6>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="10">
          <file-pond ref="doc1" label-idle="Trascina o seleziona un documento" allow-multiple="false" max-files="1"/>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="2">        
          <b-button variant="success" size="lg" v-on:click="downloadDoc1()"><font-awesome-icon icon="file-download" /> Scarica</b-button>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h6>Documento 2</h6>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="10">
          <file-pond ref="doc2" label-idle="Trascina o seleziona un documento" allow-multiple="false" max-files="1"/>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="2">        
          <b-button variant="success" size="lg" v-on:click="downloadDoc2()"><font-awesome-icon icon="file-download" /> Scarica</b-button>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row v-if="stato.admin">
        <b-col>
          <b-form-checkbox v-model="formData.componente.globale" :value="true" :unchecked-value="false">Rendi il componente globale</b-form-checkbox>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12" md="9" offset-md="1">
          <p>* Campi obbligatori</p>
        </b-col>
        <b-col>        
          <b-button variant="success" size="lg" v-on:click="updateComponente()"><font-awesome-icon icon="marker" /> Aggiorna</b-button>
        </b-col>
      </b-row>
      <br>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

var map
var markers

export default {
  name: 'elencocomponentiedit',
  data() {
    return {
      loading: true,
      option: {
        marche: [],
        tipocomponente: [],
        sottotipocomponente: []
      },
      state: {
        codcatalogo: null,
        idMarca: null,
        idTipocomponente: null,
        idSottotipocomponente: null,
        descrizione: null,
        note: null
      },
      formData:{
        componente: {
          codcatalogo: '',
          idMarca: null,
          idTipocomponente: null,
          idSottotipocomponente: null,
          descrizione: '',
          note: '',
          globale: false
        }
      }
    }
  },
  created: function(){
    this.loadComponente()
    this.option.marche = this.getListOption("marche")
    this.option.tipocomponente = this.getListOption("componente")
  },
  watch: {
    'formData.componente.idTipocomponente': function(val){
      if(!this.loading)
        this.formData.componente.idSottotipocomponente = null
      else
        this.loading = false

      if(val != null)
        this.option.sottotipocomponente = this.getListOption("sottotipocomponente/"+val)
      else
        this.option.sottotipocomponente = []
    }
  },
  methods: {
    getListOption(tipo){
      var list = []

      Vue.http.post('selectlist/'+tipo, {}, {credentials : true}).then(response => {
        if(response.body.success){
          for(var i=0; i<response.body.list.length; i++){
            if(response.body.list[i].codice)
              list.push({value: response.body.list[i].id, text: response.body.list[i].codice+" - "+response.body.list[i].nome})
            else
              list.push({value: response.body.list[i].id, text: response.body.list[i].nome})
          }
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Lista "+tipo+" non caricata correttamente.",
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Lista "+tipo+" non caricata correttamente.",
            type: 'error'
        })
      })

      return list
    },
    updateComponente(){
      var formSend = new FormData()
      formSend.append("body", JSON.stringify({componente: this.formData.componente}))

      if(this.$refs.doc1.getFiles().length == 1)
        formSend.append('doc1', this.$refs.doc1.getFiles()[0].file, this.$refs.doc1.getFiles()[0].file.name)
      
      if(this.$refs.doc2.getFiles().length == 1)
        formSend.append('doc2', this.$refs.doc2.getFiles()[0].file, this.$refs.doc2.getFiles()[0].file.name)
      
      Vue.http.post('elenco/componenti/update/'+this.$route.params.id, formSend, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Componente aggiornata con successo!',
            type: 'success'
          })
          this.$router.push('/elenco/componenti')
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }

          Vue.notify({
              group: 'global',
              title: 'Problemi durante la modifica',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    },
    loadComponente(){
      Vue.http.post('elenco/componenti/load/'+this.$route.params.id, {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.formData = response.body.data
        }else{
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
        }
      }, response => {})
    },
    downloadDoc1(){
      window.open(Vue.prototype.$hostlink+"elenco/componenti/download/0/"+this.$route.params.id)
    },
    downloadDoc2(){
      window.open(Vue.prototype.$hostlink+"elenco/componenti/download/1/"+this.$route.params.id)
    }
  },
  computed: {
    ...mapGetters(['stato'])
  }
}
</script>

<style scoped>
#codcatalogo{
  text-indent: 160px;
}

#idMarca{
  text-indent: 85px;
}

#numserie{
  text-indent: 125px;
}

#idTipocomponente{
  text-indent: 220px;
}

#idSottotipocomponente{
  text-indent: 255px;
}

#descrizione{
  text-indent: 120px;
  line-height: 1.8;
}

#note{
  text-indent: 70px;
  line-height: 1.8;
}
</style>